import React from "react";
import {isMobile} from "../utilities/Functions";

class AboutUsHowItWorksForEndUser extends React.Component {
    render() {
        const isMobileDevice = isMobile();

        const darkBlueColor = '#3B3F4E'
        const lightBlueColor = '#5D677F'
        const orangeColor = '#E35335'
          
        const containerStyle = {
            paddingBottom: isMobileDevice ? '60px' : '100px',
            paddingTop: '40px',
            paddingLeft: isMobileDevice ? '0px' : '0px',
            paddingRight: isMobileDevice ? '10px' : '40px',
            borderBottom: '1px solid #ddd',
            boxSizing: 'border-box',
            overflowX: 'scroll',
        };
    
        const titleStyle = {
            fontSize: isMobileDevice ? '18px' : '25px',
            fontWeight: 'bold',
            marginBottom: '0px',
            textAlign: 'left',
            color: darkBlueColor,
        };

        const textStyle = {
            marginTop: '5px',
            textAlign: 'left',
            fontSize: isMobileDevice ? '9px' : '11px',
            wordBreak: 'break-word',
            overflowWrap: 'break-word', // Ensure long words break and wrap
            color: lightBlueColor,
        };
    
        const boxContainerStyle = {
            display: 'flex',
            paddingLeft: isMobileDevice ? '10px' : '40px',
            flexDirection: isMobileDevice ? 'column' : 'row',
            flexWrap: 'wrap',
            gap: isMobileDevice ? '10px' : '20px',
            justifyContent: isMobileDevice ? 'center' : 'space-between',
            alignItems: isMobileDevice ? 'center' : 'flex-start',
          };

        const mobileRowStyle = {
            display: 'flex',
            gap: '10px',
            flexDirection: 'row',
            justifyContent: 'center',
            width: isMobileDevice ? '100%' : 'auto',
        };
    
        const mobileBoxStyle = {
            flex: '1 1 45%',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '10px',
            textAlign: 'center',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '180px',
            boxSizing: 'border-box',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        };

        const rowStyle = {
            display: 'flex',
            gap: '30px',
            flexDirection: 'row',
            justifyContent: 'center',
            width: isMobileDevice ? '100%' : '80%',
        };
    
        const boxStyle = {
            flex: 1,
            padding: '20px',
            border: '1px',
            borderRadius: '10px',
            textAlign: 'center',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '180px',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        };

        const separatorStyle = {
            width: '100%',
            height: '1px',
            backgroundColor: '#ddd',
            marginBottom: '40px',
        };

        return (
            <section id="how-it-works" style={containerStyle}>
                {/* <div style={separatorStyle}></div> */}
                <h2 style={{ fontSize: '2em', marginBottom: '40px' }}>How it works</h2>
                {isMobileDevice ? (
                <div style={boxContainerStyle}>
                <div style={mobileRowStyle}>
                    <div style={mobileBoxStyle}>
                        <span style={titleStyle}>1️⃣ Apply to Be a Creator! ✍️</span>
                        <span style={textStyle}>It only takes 50 seconds to kickstart your creator journey!</span>
                    </div>
                    <div style={mobileBoxStyle}>
                        <span style={titleStyle}>2️⃣ Get Your Template Account 🧑‍💻</span>
                        <span style={textStyle}>Once approved, you’ll have a ready-made profile waiting for you.</span>
                    </div>
                </div>
                <div style={mobileRowStyle}>
                    <div style={mobileBoxStyle}>
                        <span style={titleStyle}>3️⃣ Customize Your Info 🛠️</span>
                        <span style={textStyle}>Set your bio, pricing, and conversation topics—make it yours!</span>
                    </div>
                    <div style={mobileBoxStyle}>
                        <span style={titleStyle}>4️⃣ Set Your Question Limit (Optional) ⏰</span>
                        <span style={textStyle}>Control your time with a limit on unanswered questions to manage your availability better.</span>
                    </div>
                </div>
                <div style={mobileRowStyle}>
                    <div style={mobileBoxStyle}>
                        <span style={titleStyle}>5️⃣ Share with Your Followers 🚀</span>
                        <span style={textStyle}>Tell your followers on social media where they can reach you!</span>
                    </div>
                    <div style={mobileBoxStyle}>
                        <span style={titleStyle}>6️⃣ Answer and Earn! 💸</span>
                        <span style={textStyle}>You get paid for every question you answer!</span>
                    </div>
                </div>
                </div>
                ) : (
                <div style={boxContainerStyle}>
                <div style={rowStyle}>
                    <div style={boxStyle}>
                        <span style={titleStyle}>1️⃣ Apply to Be a Creator! ✍️</span>
                        <span style={textStyle}>It only takes 50 seconds to kickstart your creator journey!</span>
                    </div>
                    <div style={boxStyle}>
                        <span style={titleStyle}>2️⃣ Get Your Template Account 🧑‍💻</span>
                        <span style={textStyle}>Once approved, you’ll have a ready-made profile waiting for you.</span>
                    </div>
                </div>
                <div style={rowStyle}>
                    <div style={boxStyle}>
                        <span style={titleStyle}>3️⃣ Customize Your Info 🛠️</span>
                        <span style={textStyle}>Set your bio, pricing, and conversation topics—make it yours!</span>
                    </div>
                    <div style={boxStyle}>
                        <span style={titleStyle}>4️⃣ Set Your Question Limit (Optional) ⏰</span>
                        <span style={textStyle}>Control your time with a limit on unanswered questions to manage your availability better.</span>
                    </div>
                </div>
                <div style={rowStyle}>
                    <div style={boxStyle}>
                        <span style={titleStyle}>5️⃣ Share with Your Followers 🚀</span>
                        <span style={textStyle}>Tell your followers on social media where they can reach you!</span>
                    </div>
                    <div style={boxStyle}>
                        <span style={titleStyle}>6️⃣ Answer and Earn! 💸</span>
                        <span style={textStyle}>You get paid for every question you answer!</span>
                    </div>
                </div>
            </div>
            )}
            </section>
         ); 
        }
    }

    export default AboutUsHowItWorksForEndUser;